import * as React from "react";
import styled from "@emotion/styled";
import FormGroup from "@mui/material/FormGroup";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import type { SwitchProps } from "@mui/material/Switch";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: "1!important",
    backgroundColor: "#CCC",
    boxSizing: "border-box",
  },
}));
interface ISwitch extends SwitchProps {
  label?: React.ReactNode;
  placeholder?: string;
}
function SwitchComponent({ label, placeholder, ...rest }: ISwitch) {
  return (
    <>
      {label && (
        <FormGroup
          sx={{
            color: "#1F4970",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 4px",
          }}
        >
          {label}
        </FormGroup>
      )}
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <AntSwitch
          slotProps={{ input: { "aria-label": "ant design" } }}
          {...rest}
        />
      </Stack>
    </>
  );
}
export default SwitchComponent;
